import { render, staticRenderFns } from "./AdminUserForm.vue?vue&type=template&id=57e58949"
import script from "./AdminUserForm.vue?vue&type=script&lang=ts"
export * from "./AdminUserForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports